import { FC } from 'react';

import { SettingsPageMetadata } from '@/shared';

const Metadata: FC = () => <SettingsPageMetadata scope='Account' segments={['Security']} />;

export default Metadata;
